import { authStorage, request, refreshSession } from './api'

export async function login(credentials) {
  const result = await request('/token/verify', {
    server: 'auth',
    method: 'POST',
    data: credentials,
    form: true,
  })

  const token = result.data?.token || {}
  authStorage.setTokens({
    accessToken: token.access_token,
    authToken: token.auth_token,
    crsfToken: token.crsf_token,
  })
  authStorage.setUserModel(result.data)
  return result.data
}

// HTTP requests and socket connections share one token renewal.
export const refreshAccessToken = refreshSession
export async function logout() {
  const token = authStorage.getAccessToken()
  try {
    if (token) {
      await request('/token/logout', {
        server: 'auth',
        method: 'POST',
        data: { token },
        form: true,
      })
    }
  } finally {
    authStorage.clear()
  }
}
